<template>
    <div>
        <div class="layout-column margin-b-25">
            <h3 class="margin-b-10 layout-row">Your pixel ID
              <info-icon>You can find your Pixel ID in your Tiktok ads manager under <b>Assets &gt; Event</b>.</info-icon>
            </h3>
	        <div class="">
		        <input-field v-model="appConfig['pixel']" placeholder="eg. C6BD9A5MP02182KUTCC0"
		                     @input="$emit('update', $event.target.value, 'pixel')" />
	        </div>
	        <p>
		        Tiktok pixel app will automatically track these events throughout your funnel:
	        </p>
	        <table class="events-list">
		        <tr>
			        <td>
				        <b>PageView and ViewContent</b>
			        </td>
			        <td>
				        When a funnel page loads.
			        </td>
		        </tr>
		        <tr>
			        <td>
				        <b>AddToCart</b>
			        </td>
			        <td>
				        When a customer opts in (ie. an email is collected).
			        </td>
		        </tr>
		        <tr>
			        <td>
				        <b>PlaceAnOrder</b>
			        </td>
			        <td>
				        When a purchase occurs in checkout or OTO steps.
			        </td>
		        </tr>
		        <tr>
			        <td>
				        <b>InitiateCheckout and AddPaymentInfo</b>
			        </td>
			        <td>
				        Triggered when a customer attempts to purchase, clicking the submit button on a checkout step.
			        </td>
		        </tr>
	        </table>
        </div>

	    <div class=" alert_box orange">
		    <div class="icon">
			    <inline-svg :src="require('@/assets/img/alert_icon_yellow.svg')" />
		    </div>
		    <span>
			    Got any feedback or want to report any issues? <b class="let-us-know" @click="openIntercom">Let us know!</b>
		    </span>
	    </div>
    </div>
</template>

<script>
import InfoIcon from "@/components/base/info-icon";
import VButton from "@/components/base/v-button";
import VSwitch from "@/components/base/v-switch";
import InputField from "@/components/base/input-field";
export default {
    name: 'tiktokPixel',
    props: ['dataBufferObject'],
    components: {
	    InputField,
	    VSwitch,
	    VButton,
	    InfoIcon,
    },
    computed: {
    },
    data() {
        return {
	        appConfig: {},
        }
    },
    methods: {
	    openIntercom() {
		    window.Intercom("showNewMessage", "Tiktok pixel app feedback:\n");
	    },
    },
    created(){
        if(this.dataBufferObject) {
          this.appConfig = this.dataBufferObject;
        } else {
            this.appConfig = JSON.parse(`{"pixel":""}`)
        }
    }
}
</script>
<style lang="scss" scoped>
.let-us-know {
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}
}
.events-list {
	border-spacing: 0;
	td {
		padding: 5px 6px;
		border-top: 1px solid $light-grey;
		line-height: 30px;
	}
	tr:last-child {
		td {
			border-bottom: 1px solid $light-grey;
		}
	}
}
</style>
